import { noop } from 'lodash';
import React, { Component } from 'react';
import styled, { css } from 'styled-components';
import { FontFamily } from '@zocdoc-frontend-common/styles-typography';
import { navy, white, coral, grey10 } from '@zocdoc/branding/colors';

const CountBase = css`
    font: 15px/20px ${FontFamily.SharpSansSemibold};
    cursor: pointer;
    height: 40px;
    min-width: 40px;
    box-sizing: border-box;
    padding: 10px 16px 0;
    text-align: center;
    user-select: none;

    ${(p) =>
        p.searchHeaderExperiment &&
        css`
            border-radius: 4px;
            font-family: ${FontFamily.SharpSansBold};
        `}
`;

const SeenCount = styled.div`
    ${CountBase}
    background-color: ${white};
    color: ${navy};

    &:hover {
        background-color: ${navy};
        color: ${white};
    }

    ${(p) =>
        p.searchHeaderExperiment &&
        css`
            background-color: ${grey10};

            &:hover {
                background-color: ${navy};
            }
        `}
`;

const UnseenCount = styled.div`
    ${CountBase}
    background-color: ${coral};
    color: ${white};

    &:hover {
        background-color: ${navy};
    }
`;

const ActiveCount = styled.div`
    ${CountBase}
    background-color: ${navy};
    color: ${white};
`;

/**
 * @param {boolean} active
 * @param {number} count
 * @param {function(): void} onClick
 * @param {boolean} shouldShowNewSearchHeader
 * @returns {JSX.Element}
 */
export default class NotificationCount extends Component {
    static defaultProps = {
        active: false,
        onClick: noop,
    };

    render() {
        const { active, count, onClick, shouldShowNewSearchHeader } =
            this.props;

        let Count;
        if (active) {
            Count = ActiveCount;
        } else {
            Count = count > 0 ? UnseenCount : SeenCount;
        }

        return (
            <Count
                searchHeaderExperiment={shouldShowNewSearchHeader}
                active={active}
                data-test="notification-count"
                onClick={onClick}
            >
                {count}
            </Count>
        );
    }
}
